import UpploadBtn from './UpploadBtn';

export default UpploadBtn;
